import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopHardware = dynamic(() => import("../components/hardware/DesktopHardware"), {
  loading: () => <Loading />
})

const MobileHardware = dynamic(() => import("../components/hardware/MobileHardware"), {
  loading: () => <Loading />
})

const hardware = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Android POS Machines, Hardware, and Peripheral Devices</title>
        <meta name="description" content="Discover QueueBuster POS: Advanced Android POS machines, hardware and peripheral devices designed to enhance operations with seamless efficiency and reliability" />
        <link rel="canonical" href="https://queuebuster.co/pos-hardware-partners" />
        <link rel="alternate" href="https://queuebuster.co/pos-hardware-partners" hrefLang="en-us" />
        <meta property="og:title" content="Android POS Machines, Hardware, and Peripheral Devices" />
        <meta property="og:description" content="Discover QueueBuster POS: Advanced Android POS machines, hardware and peripheral devices designed to enhance operations with seamless efficiency and reliability" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/hardware.jpg" />
        <meta property="og:url" content="https://queuebuster.co/pos-hardware-partners" />
      </Head>
      {
        mobileView ? <MobileHardware /> : <DesktopHardware />
      }
    </>
  )
}

export default hardware